import { useSearchParams } from 'react-router-dom';

import type { Kiosk } from '../@types';
import { KioskType } from '../@types';

const getKioskType = (model: string | null): KioskType | null => {
  switch (model) {
    case 'AllMighty':
      return KioskType.ALL_MIGHTY;
    case 'BATablet':
      return KioskType.BA_TABLET;
    case 'CTSDigitalSignage':
      return KioskType.CTS_DIGITAL_SIGNAGE;
    case 'EloTouch':
      return KioskType.ELO_TOUCH;
    default:
      return model as KioskType;
  }
};

export const useKioskParams = (): Kiosk | undefined => {
  const kioskMode = process.env.REACT_APP_KIOSK_MODE === 'true';

  const [searchParams] = useSearchParams();

  if (!kioskMode) return;

  const searchParamsId = searchParams.get('kioskId');
  const searchParamsModel = searchParams.get('kioskModel');
  const id = searchParamsId;
  const model = getKioskType(searchParamsModel);

  if (!id || !model) {
    console.warn(
      'Missing either a kioskId or kioskModel URL parameter, both of which are required.',
    );
  }

  return id ? ({ id, model } as Kiosk) : undefined;
};
